<div class="switch" (click)="toggle()">
  <input type="checkbox" [checked]="checkedControl.value" />
  <span class="slider round"></span>
</div>
